<template>
    <div>

        <div v-if="!getMember.equipe_club || !getMember.equipe_club.length>0">
            <div class="row">
                <div class="col-md-12">
                    <div class="box box-primary">
                        <div class="box-body">
                            <p>
                                Ce membre ne se trouve dans aucun comité
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <form role="form" v-if="getMember.equipe_club && getMember.equipe_club.length>0">
            <div class="row">
                <div class="col-md-12">
                    <div class="box box-primary">
                        <div class="box-header with-border">
                            <h3 class="box-title">Occupe ({{getMember.equipe_club.length}} places en comité club)</h3>
                        </div>
                        <div class="box-body">
                            <table id="tableComite"
                                   class="table table-hover table-striped table-bordered">
                                <thead>
                                <tr>
                                    <th>Club</th>
                                    <th>Place</th>
                                    <!--<th>Afficher dans son MyABFT</th>-->
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(equipe) in groupByClub()">
                                    <td>
                                        <router-link
                                                v-if="equipe[0].club"
                                                :to="{ name: 'Club', params: { club_id: equipe[0].club.id }}">{{ equipe[0].club.nameFormat | uppercase }}
                                        </router-link>
                                    </td>
                                    <td>
                                        <span v-for="(poste,index) in orderByPoste(equipe)">{{poste.poste_club.poste}}<span v-if="index+1 < orderByPoste(equipe).length">, </span></span>

                                    </td>
                                    <!--<td>-->
                                        <!--<i class="fa fa-refresh fa-spin" v-if="loading[equipe[0].id_club]==true"></i>-->
                                        <!--<select name="" v-if="!loading[equipe[0].id_club] || loading[equipe[0].id_club]==false"-->
                                                <!--@change="setClubInExtranet(equipe[0].id_club,equipe[0].show_in_extranet)" v-model="equipe[0].show_in_extranet" id="">-->
                                            <!--<option value="0">NON</option>-->
                                            <!--<option value="1">OUI</option>-->
                                        <!--</select>-->
                                    <!--</td>-->
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import {ErrorBag} from 'vee-validate';
    import Datepicker from 'vuejs-datepicker';

    var $ = require('jquery');
    var variables = require('../../../assets/js/variables')
    var _ = require('underscore')
    var moment = require('moment')

    export default {
        data() {
            return {
                loading: {},
                dataTableRankingMember: null,
            }
        },
        computed: {
            ...mapGetters({
                getMember: 'getMember',
                getRoute: 'getRoute',
            }),

        },
        mounted: function () {
            var these = this
            // this.$nextTick(function () {
            //     setTimeout(function () {
            //         these.refreshListings()
            //     }, 1000)
            // })
        },
        created() {
        },
        watch: {},
        components: {},
        methods: {
            ...mapActions({}),
            refreshListings: function () {
                // this.dataTableRankingMember = $("#rankingMember").DataTable({
                //     language: variables.dt_french(),
                //     "paging": true,
                //     "ordering": true,
                //     "info": true,
                //     "autoWidth": true,
                // });
            },
            orderByPoste: function (equipe) {
                return _.sortBy(equipe, function (equipe) {
                    return equipe.poste_club.ordre
                })
            },
            groupByClub: function () {
                let groupe = _.groupBy(this.getMember.equipe_club, function (equipe) {
                    return equipe.id_club
                })
                return groupe;
            },
            setClubInExtranet: function (id_club, showInExtranet) {
                Vue.$set(this.loading, id_club, true);
                const self = this
                this.$http.post(this.getRoute('setEquipeInExtranet'),
                    {
                        id_club: id_club,
                        id_membre:self.getMember.id,
                        show_in_extranet: showInExtranet
                    })
                    .then(function (response) {
                        self.$noty.success("Modification effectuée")
                        self.loading[id_club] = false;
                    }, (response) => {
                        self.$noty.error("Modification échouée")
                        self.loading[id_club] = false
                    });
            },
            formatDate: function (value, fmtIn = 'YYYY-MM-DD hh:mm:ss', fmtOut = 'DD/MM/YYYY HH:mm') {
                if (value == null) return ''
                return moment(value, fmtIn).format(fmtOut)
            },
            get_place: function (numero) {
                if (numero == 1)
                    return "1<sup>er</sup>";
                else (numero >= 2)
                return numero + "<sup>ème</sup>";
            }
        },
        filters: {
            idFormat: function (value) {
                return new Intl.NumberFormat("de-DE").format(value)
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/Secretariat/Membre/ListingComites.vue